import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/MyContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import { signInWithEmail } from "@/hooks/useAuthentication";
import { supabase } from "@/lib/supabase";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [debug, setDebug] = useState("");

  const { user, login } = useAuth();
  const navigate = useNavigate();
  // useEffect(()=>{

  // (async()=>{
  //   const user =await supabase.auth.getUser();
  //   console.log(user);
  //   if(user.data.user){
  //     navigate("/dashboard");
  //   }
  // })()
  // },[])
  console.log(user, 'login users falaananflsdf')
  useEffect(() => {
    if (user) {
      console.log(user, 'login users useEffect')
      if (user.isAdmin === true) {
        console.log(1, 'navigating to /admin')
        navigate("/admin");
      } else {
        console.log(2, 'navigating to /dashboard')
        navigate("/dashboard");
      }
    }
  }, [user, navigate]);
  
  const { toast } = useToast();

  // // Load initial data only once when component mounts
  // useEffect(() => {
  //   // Reset form state on component mount
  //   setEmail('');
  //   setPassword('');
  //   setErrorMessage('');
  //   setDebug('');

  //   // Get latest users only once when the component loads
  //   const fetchInitialData = () => {
  //     const latestUsers = getAllUsers();
  //     console.log(`Login page loaded - Available users: ${JSON.stringify(latestUsers.map(u => u.email))}`);
  //   };

  //   fetchInitialData();

  //   // Check for deleted account in localStorage
  //   const deletedEmailsStr = localStorage.getItem("deletedEmails");
  //   if (deletedEmailsStr) {
  //     const deletedEmails = JSON.parse(deletedEmailsStr);
  //     console.log(`Deleted emails in system: ${JSON.stringify(deletedEmails.map((d: any) => d.email))}`);
  //   }
  // }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMessage("");
    setDebug("");
    setIsSubmitting(true);

    if (!email.trim() || !password.trim()) {
      setErrorMessage("Email and password are required");
      return;
    }
    try {
      const response = await login(email, password);
      navigate("/dashboard");
      toast({
        title: "Login Successful",
        description: "Welcome back!",
      });
      
     navigate("/dashboard");
    } catch (error) {
      setErrorMessage(error.message);
      console.error("Signup error:", error);
    } finally {
      setIsSubmitting(false);
    }

    // try {
    //   const response = await signInWithEmail({
    //     email,
    //     password,
    //   });
    //   console.log(response, 'login response')
    //   if (response.error) {
    //     throw response.error;
    //   }
    //     navigate("/dashboard");
    // } catch (error) {
    //   setErrorMessage(error.message);
    //   console.error("Signup error:", error);
    // } finally {
    //   setIsSubmitting(false);
    // }
    // setIsSubmitting(true);

    // try {
    //   console.log(`Attempting login for email: ${email}`);

    //   // For debugging, check if the email exists in our user list
    //   const allUsers = getAllUsers();
    //   const normalizedEmail = email.toLowerCase().trim();
    //   const userExists = allUsers.some(u => u.email.toLowerCase() === normalizedEmail);

    //   setDebug(`User exists in system: ${userExists ? 'Yes' : 'No'}`);
    //   console.log(`User exists in system: ${userExists}, All users: ${JSON.stringify(allUsers.map(u => u.email))}`);

    //   // Check if email is in deleted list
    //   const deletedEmailsStr = localStorage.getItem("deletedEmails");
    //   if (deletedEmailsStr) {
    //     const deletedEmails = JSON.parse(deletedEmailsStr);
    //     const isDeleted = deletedEmails.some((d: any) => d.email.toLowerCase() === normalizedEmail);

    //     if (isDeleted) {
    //       setDebug(`Account has been deleted and cannot be used to login`);
    //       console.log(`Attempted login with deleted account: ${email}`);
    //       setErrorMessage('This account has been deleted. Please sign up for a new account.');
    //       throw new Error('Account deleted');
    //     }
    //   }

    //   await login(email, password);
    //   toast({
    //     title: "Login Successful",
    //     description: "Welcome back!",
    //   });
    //   navigate('/dashboard');
    // } catch (error) {
    //   console.error('Login error:', error);
    //   const errorMsg = error instanceof Error ? error.message : 'An error occurred during login';
    //   setErrorMessage(errorMsg);
    //   toast({
    //     title: "Login Failed",
    //     description: errorMsg,
    //     variant: "destructive",
    //   });
    // } finally {
    //   setIsSubmitting(false);
    // }
  };

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-64px-12rem)] p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">
            Welcome back
          </CardTitle>
          <CardDescription className="text-center">
            Login to your account
          </CardDescription>
        </CardHeader>

        <form onSubmit={handleSubmit}>
          <CardContent className="space-y-4">
            {errorMessage && (
              <div className="p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm">
                {errorMessage}
              </div>
            )}

            {debug && (
              <div className="p-3 bg-blue-50 border border-blue-200 text-blue-700 rounded-md text-sm">
                Debug: {debug}
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="name@example.com"
                required
                autoComplete="email"
              />
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Password</Label>
                <Link
                  to="/forgot-password"
                  className="text-sm text-blue-600 hover:text-blue-800"
                >
                  Forgot password?
                </Link>
              </div>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
          </CardContent>

          <CardFooter className="flex flex-col space-y-4">
            <Button type="submit" className="w-full" disabled={isSubmitting}>
              {isSubmitting ? "Signing in..." : "Sign in"}
            </Button>

            <div className="text-center text-sm">
              Don't have an account?{" "}
              <Link
                to="/signup"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                Sign up
              </Link>
            </div>
          </CardFooter>
        </form>
      </Card>
    </div>
  );
};

export default Login;
